import { Pipe, PipeTransform } from '@angular/core';
import { NestedDirective } from '../../component/nested.directive';
import { NestedHelpersService } from '../../service/nested-helpers.service';

@Pipe({
    name: 'filterNested'
})
export class FilterNestedPipe implements PipeTransform {
    constructor(private nestedHelpersService: NestedHelpersService) {}

    transform(value?: NestedDirective[], tag?: string): NestedDirective[] {
        return this.nestedHelpersService.filter(value, tag);
    }
}
